<!-- LABEL -->
<div class="ui-radio-header" *ngIf="label">
  <p class="label">{{ label }}</p>
  <app-ui-tooltip *ngIf="tooltipText?.length" size="small" [content]="tooltipText"></app-ui-tooltip>
</div>
<!-- RADIO BUTTON ITEMS -->
<div class="ui-radio-items" [ngClass]="{ 'has-error': hasError, horizontal: horizonalPosition }">
  <ng-content select="app-ui-radio-button"></ng-content>
</div>
<!-- ERROR -->
<div class="ui-radio-error" [class.has-error]="hasError">
  <span class="icon-i-close-circle"></span>
  <span>{{ 'required' | translate }}</span>
</div>
